import { render, staticRenderFns } from "./MailV2TemplateSelector.vue?vue&type=template&id=624e56ca"
import script from "./MailV2TemplateSelector.vue?vue&type=script&lang=js"
export * from "./MailV2TemplateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports